export const emojis = [
  '😌',
  '😊',
  '😄',
  '🤣',
  '😰',
  '🥰',
  '🙃',
  '😔',
  '😇',
  '🤔',
  '😩',
  '😭',
  '😤',
  '😵',
  '🤒',
  '🤤',
];
